const allSections = document.querySelectorAll('.section');

const sections = Array.from(allSections).filter(section => {
  return !section.closest('header, footer, [id*="header"], [id*="footer"], [class*="header"], [class*="footer"]');
});

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
    }
  });
}, {
  threshold: 0.1,
  rootMargin: '0px 0px -20% 0px'
});

sections.forEach(section => observer.observe(section));

window.addEventListener('load', () => {
  sections.forEach(section => {
    const rect = section.getBoundingClientRect();
    const threshold = window.innerHeight * 0.8;
    if (rect.top < threshold) {
      section.classList.add('is-visible');
    }
  });
});


const productRecs = document.querySelectorAll('product-recommendations');

productRecs.forEach(productRec => {
  const mutationObserver = new MutationObserver(() => {
    const section = productRec.querySelector('.section');
    if (section) {
      observer.observe(section);
      mutationObserver.disconnect();
    }
  });

  mutationObserver.observe(productRec, { childList: true, subtree: true });
});